import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-6 lg:mb-6 mb-3 md:text-2xl text-lg font-medium text-neutral-600" }
const _hoisted_2 = { class: "md:inline-block block font-semibold text-neutral-900" }
const _hoisted_3 = { class: "w-full lg:p-6 p-4 border border-gray-200 rounded" }
const _hoisted_4 = { class: "flex lg:flex-row flex-col lg:justify-between lg:items-center lg:space-x-[76px] lg:gap-0 gap-6" }
const _hoisted_5 = { class: "flex pt-4 pb-2 space-x-8 overflow-x-scroll side-scroll" }
const _hoisted_6 = { class: "flex-shrink-0" }
const _hoisted_7 = { class: "flex-shrink-0" }
const _hoisted_8 = { class: "flex-shrink-0" }
const _hoisted_9 = { class: "flex-shrink-0" }
const _hoisted_10 = { class: "flex sm:flex-row flex-col flex-shrink-0 sm:space-x-3 sm:space-y-0 space-y-3" }
const _hoisted_11 = {
  key: 0,
  class: "text-xs font-medium text-red-600"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "w-full my-6 border border-neutral-100" }, null, -1)
const _hoisted_13 = { class: "w-full" }

import { ref, onMounted, computed, watch } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import { useRouter, useRoute } from "vue-router";
import ErrorModal from "@/components/modals/ErrorModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CaseConferenceLayout',
  props: {
    isWarningMessage: {
        type: Boolean,
        default: false
    },
    isShowNav: {
        type: Boolean,
        default: true
    },
    patient: {
        type: String,
        default: ''
    }
},
  setup(__props) {

const props = __props

const router = useRouter();
const route = useRoute();
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const caseConferenceId = ref<number | null>(route.params.caseConference);
const showModal = ref<boolean>(false)

const navLink = (name:string):string => {
    if (caseConferenceId.value) {
        return `/patient/${patientId.value}/cases/${caseId.value}/case-conference/${name}/${caseConferenceId.value}/edit`
    } else {
        return `/patient/${patientId.value}/cases/${caseId.value}/case-conference/${name}`
    }
};
const routeNav = (name:string) => useRoute().path.split('/').includes(name);

const closeError = () => {
    showModal.value = false
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backTitle: "Case Conference Details",
    backLink: `/patient/${patientId.value}/cases/${caseId.value}/edit`
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, [
        _createTextVNode("Patient's Name: "),
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.patient), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).replace(navLink('information'))), ["prevent"])),
                class: _normalizeClass(["cursor-pointer text-sm font-semibold", [ routeNav('information') ? 'text-primary-600': 'text-neutral-400']])
              }, " Information ", 2)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (caseConferenceId.value ? _unref(router).replace(navLink('factors')) : showModal.value = true), ["prevent"])),
                class: _normalizeClass(["cursor-pointer text-sm font-semibold", [ routeNav('factors') ? 'text-primary-600': 'text-neutral-400']])
              }, " Factors ", 2)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (caseConferenceId.value ? _unref(router).replace(navLink('recommendation')) : showModal.value = true), ["prevent"])),
                class: _normalizeClass(["cursor-pointer text-sm font-semibold", [ routeNav('recommendation') ? 'text-primary-600': 'text-neutral-400']])
              }, " Recommendation ", 2)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", {
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (caseConferenceId.value ? _unref(router).replace(navLink('minutes-of-the-meeting')) : showModal.value = true), ["prevent"])),
                class: _normalizeClass(["cursor-pointer text-sm font-semibold", [ routeNav('minutes-of-the-meeting') ? 'text-primary-600': 'text-neutral-400']])
              }, " Minutes of the Meeting ", 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _renderSlot(_ctx.$slots, "actionButtons")
          ])
        ]),
        (__props.isWarningMessage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Kindly save your changes first before browsing through other pages / tabs* "))
          : _createCommentVNode("", true),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _createVNode(ErrorModal, {
        onClose: closeError,
        show: showModal.value,
        content: "Prior to proceeding, please save the details in the information tab."
      }, null, 8, ["show"])
    ]),
    _: 3
  }, 8, ["backLink"]))
}
}

})